import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this example we will use auralization in virtual reality for scientific purpose. At first a research question need to be defined. For example: Does the cognitive performance vary in different background speech conditions?",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/27/principle/principle-01.png`,
              styles: {
                maxWidth: "80%",
              },
            },
          },
        },
      },
    },
  },
};

export default principle;
